import AddAttachmentPointCard from './AddAttachmentPointCard';

export default AddAttachmentPointCard;
